import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import CountryLeagueFilter from "@/components/LichThiDauByCountry/CountryLeagueFilter";
import useBangXepHangByCountry from "@/components/BangXepHangByCountry/useBangXepHangByCountry";
import LeagueStandingSidebar from "@/components/BangXepHangByLeagueSidebar/LeagueStandingSidebar";
import "@/components/LichThiDauFull/index.css";
import "@/components/LichThiDauByLeagueSidebar/index.css";
import "@/components/BangXepHangByLeagueSidebar/index.css";

/**
 * @param {object} props
 * @param {string} props.country
 */
export default function BangXepHangByCountrySidebar({ country: countrySlug }) {
  const {
    themeStyle,
    leagues,
    selectedId,
    setSelectedId,
    activeLeagues,
    standingsMap,
    waiting,
    failed,
    countryLoading,
  } = useBangXepHangByCountry(countrySlug);

  const league = activeLeagues[0] || null;
  const standingsRes = league ? standingsMap[String(league.id)] : null;
  const totalStandings = standingsRes?.totalStandings || [];
  const colorInfos = standingsRes?.colorInfos || [];
  const hasContent = totalStandings.length > 0;

  return (
    <div
      className="kbv-ltd-full kbv-ltd-sb kbv-bxh-sb text-[var(--theme-text)]"
      style={themeStyle}
    >
      <h2 className="kbv-bycountry-sb-title">Bảng xếp hạng</h2>
      <div className="kbv-ltd-sb-filters">
        <CountryLeagueFilter
          compact
          leagues={leagues}
          selectedId={selectedId}
          onSelect={setSelectedId}
          themeStyle={themeStyle}
          loading={countryLoading}
        />
      </div>
      <div className="kbv-bycountry-scroll kbv-bxh-sb-body">
        {failed ? (
          <NoData message="Không có bảng xếp hạng" />
        ) : !selectedId || waiting ? (
          <LtdLoading compact />
        ) : !hasContent ? (
          <NoData message="Không có bảng xếp hạng" />
        ) : (
          <LeagueStandingSidebar
            key={league.id}
            standings={totalStandings}
            colorInfos={colorInfos}
          />
        )}
      </div>
    </div>
  );
}
